import { render, staticRenderFns } from "./wxLuckyTurntable.vue?vue&type=template&id=38ec350d"
import script from "./wxLuckyTurntable.vue?vue&type=script&lang=js"
export * from "./wxLuckyTurntable.vue?vue&type=script&lang=js"
import style0 from "./wxLuckyTurntable.vue?vue&type=style&index=0&id=38ec350d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports